import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useInView } from 'react-intersection-observer';

import { TransitionLink } from './TransitionLink';

export const Header = ({ props }) => {

    const { pathname } = props;

    const data = useStaticQuery(graphql`
        query {
            profilePic: contentfulAsset(contentful_id: {eq: "6z4EKuoA7WjfxmJpPeZNbN"}) {
                gatsbyImageData(placeholder: BLURRED, width: 60)
            }
        }
    `);

    const { profilePic } = data;

    const { ref: navRef, inView: navInView } = useInView({
        threshold: 0,
    });

    const { ref: proRef, inView: proInView } = useInView({
        threshold: 0,
        initialInView: true
    });

    const scrolled = !navInView;
    const isMain = pathname === "/";

    return (
        <>
            <header className={`fixed w-full z-10 transition-all duration-[250ms] bg-surface/70 backdrop-blur-xl ${scrolled ? 'hover:bg-surface' : ''}`}>
                <a
                    href="#skip"
                    className="absolute -top-[1000%] focus:top-0 focus:left-1/3 focus:right-1/3 focus:bg-surface-container-lowest focus:text-on-surface focus:px-8 focus:py-2 focus:text-center focus:no-underline focus:shadow-md focus:rounded focus:z-[4]"
                >
                    Skip to main content
                </a>
                <nav className="flex mx-auto max-w-[1280px]">
                    <div className={`flex ml-auto transition-all duration-[250ms] ${scrolled ? 'w-1/4 my-3 max-[767px]:w-1/2' : 'w-full my-[0.9em]'} max-[414px]:w-full max-[414px]:mr-0`}>
                        <TransitionLink
                            to="/"
                            delay={isMain ? 1.5 : 0.1}
                            activeClassName="text-secondary"
                        >
                            home
                        </TransitionLink>
                        <TransitionLink
                            to="/about"
                            delay={isMain ? 1.6 : 0.2}
                        >
                            about
                        </TransitionLink>
                        <TransitionLink
                            to="/work"
                            delay={isMain ? 1.7 : 0.3}
                        >
                            work
                        </TransitionLink>
                        <TransitionLink
                            to="/contact"
                            delay={isMain ? 1.8 : 0.4}
                        >
                            contact
                        </TransitionLink>
                    </div>
                </nav>
                {/* Subtle bottom separator — no hard border, tonal shift at 15% opacity */}
                <div className="absolute bottom-0 left-0 w-full h-[1px] bg-surface-container-low opacity-[0.15]" />
                <div className={`absolute w-[60px] transition-all duration-[250ms] p-[0.65em] z-[-1] max-[414px]:hidden ${!proInView ? 'top-0' : '-top-[100px]'}`}>
                    <GatsbyImage image={profilePic?.gatsbyImageData} alt="me" aria-hidden={true} />
                </div>
            </header>
            <div ref={navRef} />
            <div
                ref={proRef}
                className={`pointer-events-none ${pathname === "/" ? "absolute top-[52%] left-1/2 -ml-[150px] w-[300px] h-[5px] max-[767px]:top-[45%] max-[480px]:top-[36%]" : ""}`}
            />
        </>
    );
};
